import { http } from '../../util/http';

export default class VehicleUtilService {
	static get() {
		return http.get('/utils');
	}
}
